import { RATING_LEVELS } from "../utils/Constants";

const formatValue = (field, value) => {
    if (field.isTextBox) return value ?? "";
    const level = Number(value);
    if (!RATING_LEVELS.includes(level)) return "";
    if (field.isRating) return `L${level}`;
    if (field.isTickRating) return `${level} ${level === 1 ? "Tick" : "Ticks"}`;
    return "";
};

const ReadOnlyField = ({ field, value }) => {
    if (!(field.isTextBox || field.isRating || field.isTickRating)) return null;
    return (
        <input
            type="text"
            className="common-input"
            value={formatValue(field, value)}
            aria-label={field.label}
            disabled
            readOnly
        />
    );
};

export default ReadOnlyField;